import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import lang from '@blade/common/pages/alert-details/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let imagesBox = class imagesBox extends Vue {
    details;
    cardLiImg;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    isBlur = localStorage.getItem('privacyMode') === 'true';
    activeBorderColor = colors.borderItemHover;
    cardLiImgWidth = 0;
    cardLiImgHeight = 0;
    get scale() {
        return this.cardLiImgWidth / this.cardLiImgHeight;
    }
    get faceMatch() {
        return (this.details.incidentType === 'FACE_MATCH' ||
            this.details.incidentType === 'FACE_PEDESTRIAN' ||
            this.details.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED' ||
            this.details.incidentType === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED' ||
            this.details.incidentType === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED' ||
            ((this.details.incidentType === 'INCIDENT_EVERYTHING_MATCHED' || this.details.incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
                this.details.everythingAnnotation?.everythingAlertType === 'image'));
    }
    get getPanoramicImage() {
        let value = '';
        if (this.details.pedestrianAnnotation) {
            value = this.details.pedestrianAnnotation?.portraitCaptureImage;
        }
        else if (this.details.faceAnnotation) {
            value = this.details.faceAnnotation?.portraitCaptureImage;
        }
        else if (this.details.automobileAnnotation) {
            value = this.details?.automobileAnnotation?.portraitCaptureImage;
        }
        else {
            value = this.details.panoramicImage;
        }
        return value;
    }
    mounted() {
        this.cardLiImgWidth = this.$refs.cardLiImg?.offsetWidth;
        this.cardLiImgHeight = this.$refs.cardLiImg?.offsetHeight;
        console.log('details', this.details);
    }
    get getThreshold() {
        let value = '';
        if (this.details.incidentType === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
            value = (this.details.pedestrianAnnotation.value * 100).toFixed(2) + '%';
        }
        else if (this.details.incidentType === 'FACE_MATCH') {
            value = (this.details.faceAnnotation.value * 100).toFixed(2) + '%';
        }
        else if ((this.details.incidentType === 'INCIDENT_EVERYTHING_MATCHED' || this.details.incidentType === 'INCIDENT_EVERYTHING_UNMATCHED') &&
            this.details.everythingAnnotation?.everythingAlertType === 'image') {
            value = (this.details.everythingAnnotation?.value * 100).toFixed(2) + '%';
        }
        return value;
    }
    getPortraitCaptureImage() {
        let value = '';
        if (this.details.pedestrianAnnotation) {
            value = this.details.pedestrianAnnotation?.portraitCaptureImage;
        }
        else if (this.details.faceAnnotation) {
            value = this.details.faceAnnotation?.portraitCaptureImage;
        }
        else if (this.details.automobileAnnotation) {
            value = this.details?.automobileAnnotation?.portraitCaptureImage;
        }
        else if (this.details.everythingAnnotation) {
            value = this.details?.everythingAnnotation?.captureSmallImage;
        }
        else {
            value = this.details.panoramicImage;
        }
        return value;
    }
    getPortraitImage() {
        let value = '';
        if (this.details.pedestrianAnnotation) {
            value = this.details.pedestrianAnnotation?.portraitImage;
        }
        else if (this.details.faceAnnotation) {
            value = this.details.faceAnnotation?.portraitImage;
        }
        else if (this.details.automobileAnnotation) {
            value = this.details?.automobileAnnotation?.vehicleImage;
        }
        else if (this.details.everythingAnnotation) {
            value = this.details?.everythingAnnotation?.originImage;
        }
        return value;
    }
};
__decorate([
    Prop()
], imagesBox.prototype, "details", void 0);
__decorate([
    Ref()
], imagesBox.prototype, "cardLiImg", void 0);
imagesBox = __decorate([
    Component({
        name: 'imagesBox',
        components: { BlurPicture },
        i18n: {
            messages: lang,
        },
    })
], imagesBox);
export default imagesBox;
